import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Home,
  Tv,
  ShoppingBag,
  Book,
  Send,
  Headphones,
  Info,
  Search,
  FileText,
  Plus,
  LogOut,
} from "lucide-react";

import useAuth from "@/auth/useAuth";
import logo from "@/assets/logo.jpg";

const menuItems = [
  { id: 1, name: "خانه", icon: <Home className="h-5 w-5" />, path: "/" },
  {
    id: 2,
    name: "روستا نما",
    icon: <Search className="h-5 w-5" />,
    path: "/explore",
  },
  {
    id: 3,
    name: "شبکه‌ها",
    icon: <Tv className="h-5 w-5" />,
    path: "/networks",
  },
  { id: 4, name: "ایجاد", icon: <Plus className="h-5 w-5" />, path: "/create" },
  {
    id: 5,
    name: "فروشگاه",
    icon: <ShoppingBag className="h-5 w-5" />,
    path: "/shop",
  },
  { id: 6, name: "ویکی", icon: <Book className="h-5 w-5" />, path: "/wiki" },
  {
    id: 7,
    name: "ارسال سوژه خبری",
    icon: <Send className="h-5 w-5" />,
    path: "/submit-news",
  },
  {
    id: 8,
    name: "خدمات روستا تی وی",
    icon: <Headphones className="h-5 w-5" />,
    path: "/services",
  },
  {
    id: 9,
    name: "مجله خبری",
    icon: <FileText className="h-5 w-5" />,
    path: "/news",
  },
  {
    id: 10,
    name: "قوانین و مقررات",
    icon: <FileText className="h-5 w-5" />,
    path: "/rules",
  },
  {
    id: 11,
    name: "درباره ما",
    icon: <Info className="h-5 w-5" />,
    path: "/about",
  },
];

const Sidebar = () => {
  const location = useLocation();
  const { logOut } = useAuth();
  const handleLogout = () => {
    logOut();
  };

  return (
    <div className="h-full flex flex-col bg-white p-4 overflow-y-auto font-vazir">
      <div className="flex flex-col items-center justify-center mb-6">
        <div className="bg-primary rounded-full mb-2 overflow-hidden">
          <img src={logo} alt="روستا تی وی" className="w-14 h-14" />
        </div>
        <h2 className="text-lg font-bold text-primary">روستا تی وی</h2>
      </div>

      <div className="flex-1">
        <nav>
          <ul className="space-y-0">
            {menuItems.map((item, index) => {
              const isActive =
                location.pathname === item.path ||
                (item.path !== "/" && location.pathname.startsWith(item.path));

              return (
                <React.Fragment key={item.id}>
                  <li>
                    <Link
                      to={item.path}
                      className={`flex items-center gap-2 p-2 rounded-lg ${
                        isActive
                          ? "bg-green-50 text-primary"
                          : "hover:bg-green-50 text-primary hover:text-primary"
                      } text-xs font-medium`}
                    >
                      {item.icon}
                      <span>{item.name}</span>
                    </Link>
                  </li>
                  {index < menuItems.length - 1 && (
                    <hr className="border-gray-100 my-1" />
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </nav>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-100">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-2 p-2 rounded-lg text-red-500 hover:bg-red-50 text-xs font-medium"
        >
          <LogOut className="h-5 w-5" />
          <span>خروج از حساب</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
